import { render, staticRenderFns } from "./RoleEmpty.vue?vue&type=template&id=872030f4&"
import script from "./RoleEmpty.vue?vue&type=script&lang=ts&"
export * from "./RoleEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports